import styled, { css } from 'styled-components';

export const CellContainer = styled.div`
  ${({ $wasEdited, theme }) => `background: ${$wasEdited ? theme.colors.warning : 'none'}`}
  width: 100%;
  min-height: 40px;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background-color: ${({ $bgColor = 'none' }) => $bgColor};
  ${({ $bgColor }) =>
    $bgColor &&
    $bgColor !== 'none' &&
    css`
      width: 100%;
      display: flex;
      align-items: center;
      padding: 2px 6px;
      border-radius: 3px;
      color: #1f1f1f;
    `}
  ${({ $allowWrap }) =>
    $allowWrap
      ? css`
          white-space: normal;
          overflow: visible;
        `
      : css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
    ${({ travelOutside }) =>
      travelOutside &&
      css`
        display: flex;
        justify-content: center;
      `};
`;

export const StyledCellSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  color: gray;
  font-size: 0.8rem;
  white-space: pre-wrap;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'text')};
`;

export const StyledOccurrenceCel = styled.span`
  font-weight: bold;
  color: ${(props) => props.color};
`;
